import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { NotFound } from '@/shared/NotFound';
import { FullScreenSpinner } from '@/shared/ui';

// One lazily loaded chunk per surface: phones never download the admin editor.
const HomePage = lazy(() => import('@/home/HomePage'));
const AdminApp = lazy(() => import('@/admin/AdminApp'));
const HostApp = lazy(() => import('@/host/HostApp'));
const ScreenApp = lazy(() => import('@/screen/ScreenApp'));
const PlayApp = lazy(() => import('@/play/PlayApp'));

/** React Router v7 behaviour opted in early (used by BrowserRouter and tests). */
export const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true } as const;

export function AppRoutes() {
  return (
    <Suspense fallback={<FullScreenSpinner />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/host/*" element={<HostApp />} />
        <Route path="/screen/:code" element={<ScreenApp />} />
        <Route path="/j/:code" element={<PlayApp />} />
        <Route path="/play/*" element={<PlayApp />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
